<template>
  <app-view>
    <div class="textarea"><textarea v-model="content" placeholder="我们的成长离不开您的支持和建议"></textarea></div>
    <div class="input"><input v-model="contact" placeholder="您的邮箱/QQ/手机号"></div>
    <a class="submit" href="javascript:;" @click="onSend">发 送</a>
  </app-view>
</template>
<script>
  import AppView from '../components/AppView.vue'
  import {Toast} from 'mint-ui'

  export default {
    components: {AppView},
    data () {
      return {
        content: '',
        contact: ''
      }
    },
    methods: {
      async onSend () {
        if (this.content.length === 0) {
          Toast('请填写您的建议反馈')
          return
        }
        if (this.contact.length === 0) {
          Toast('请填写您的联系方式')
          return
        }
        await this.$service.other.sendSuggest({
          content: this.content,
          contact: this.contact
        })
        Toast('提交成功')
        this.$router.go(-1)
      }
    }
  }
</script>
<style scoped lang='scss'>
  .view {
    .textarea {
      padding: $app-padding;
      background-color: $color-white;
      border-bottom: $style-border;
      textarea {
        width: 100%;
        height: 200px;
        padding: $app-padding;
      }
    }
    .input {
      background-color: $color-white;
      padding: 0 $app-padding;
      input {
        width: 100%;
        height: 50px;
        padding: 0 $app-padding;
      }
    }
    .submit {
      display: block;
      margin: 0 $app-padding;
      margin-top: 20px;
      line-height: 44px;
      border-radius: 4px;
      font-size: 18px;
      text-align: center;
      color: $color-white;
      background-color: $color-red;
      &:active {
        background-color: rgba($color-red, 0.7);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?0d1361bb